module.exports = __webpack_public_path__ + "img/blinkit.cd3f6a2e.svg";